export const ACCEPTED_PHOTO_TYPES = [
    'image/bmp',
    'image/gif',
    'image/jpg',
    'image/jpeg',
    'image/png'
];

export const MAX_LISTING_PHOTOS = 50;
export const MIN_PHOTO_DIMENSION = 500;
export const NO_PHOTO_PLACEHOLDER = '/images/frend/no-photo-1.0.png';
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const PHOTO_LOAD_TIMEOUT = 60000;

export const MIN_AGENT_PHOTO_DIMENSION = 160;

export const PHOTO_VALIDATION_ERROR_MIME_TYPE = 'mime_type';
export const PHOTO_VALIDATION_ERROR_FILE_SIZE = 'file_size';
export const PHOTO_VALIDATION_ERROR_IMAGE_DIMENSIONS = 'image_dimensions';
export const PHOTO_VALIDATION_ERROR_IMAGE_LOAD_ERROR = 'image_load_error';
export const PHOTO_VALIDATION_ERROR_IMAGE_SQUARE_DIMENSIONS = 'image_square_dimensions';
